module.exports = __webpack_public_path__ + "static/media/pointing-right-stretched-fill.b49aacbf.svg";